import React from 'react';
import ArrowBack from '@svg/arrow-back.svg?react';
import { useNavigate } from 'src/utils/use-navigate';
import './back-to-policy-selection.scss';
import { useStores } from '../../store';
import { EventType } from '../../../dtos/analytics.dto';
import { keyboardClickable } from '../../../utils/a11y-utils';

interface BackToPolicySelectionProps {
    buttonLocation: string;
}

export const BackToPolicySelection: React.FC<BackToPolicySelectionProps> = ({ buttonLocation }) => {
    const { customerStore, fwVersionStore } = useStores(); // Access stores directly via hook
    const navigate = useNavigate();

    const cancelPolicySelection = async () => {
        fwVersionStore.sendGeneralEvent(EventType.LinkClicked, {
            button: 'backToPolicySelection',
            location: buttonLocation,
        });

        await customerStore.rollbackPolicyMode([customerStore.serviceId]);
        navigate(`/${customerStore.customerId}/wizard`, {
            state: {
                initialStep: 2,
                initialData: JSON.stringify({ connection: customerStore.selectedLocation }),
            }
        });
    };

    return (
        <div className="back-policy-selection-modal" {...keyboardClickable(cancelPolicySelection)}><ArrowBack />
            Back to policy selection
        </div>
    );
};